export default __webpack_public_path__ + "static/media/potilasohjeet-white.5e6c5308.svg";